import { render, staticRenderFns } from "./IndividualStep2.vue?vue&type=template&id=6d5a3b9a&scoped=true&"
import script from "./IndividualStep2.vue?vue&type=script&lang=js&"
export * from "./IndividualStep2.vue?vue&type=script&lang=js&"
import style0 from "./IndividualStep2.vue?vue&type=style&index=0&id=6d5a3b9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a3b9a",
  null
  
)

export default component.exports